<template>
    <v-app>
        <template v-if="initDone">
            <app-navigation/>
            <app-alerts/>
            <v-main transition="slide-x-transition">
                <router-view/>
            </v-main>
            <v-footer app id="poweredbynodeping" ><v-row class="color" justify="center" >Powered by <a href='https://nodeping.com'>NodePing</a></v-row></v-footer>
        </template>
        <template v-else>
            <div class="text-center" style="margin-top:64px;">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </template>
    </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";
import AppNavigation from '@/components/AppNavigation';
import AppAlerts from '@/components/AppAlerts';
import { mapState } from 'vuex';

export default {
    name: "App",
    metaInfo: {
        style: ""
    },
    components: {
        AppNavigation, AppAlerts
    },
    computed: {
        ...mapState(['initDone'])
    },
    data () {
        return {
        //
        };
    }
};
</script>

<style>
  footer a { margin-left: 1rem; }
  .passcolor { color: #366836; }
  .warncolor { color: #f60; }
  .failcolor { color: #f03d15; }
</style>
